"use client"

import { TabBarTabButton } from "@/app/pwa/components/TabBar"
import { useRouter } from "next/navigation";
import { pwaTeamTabsSettings } from "@/utils/urlHelper";
import EditIcon from "@/assets/icon/edit.svg";

export default function TeamNavigationEditButton({teamId} : {teamId:string }) {
  const router = useRouter();
  return <>
    <TabBarTabButton onClick={() => router.push(pwaTeamTabsSettings(teamId))}>
      <EditIcon className="h-4 w-4 my-1"/>
    </TabBarTabButton>
  </>
}
